export const getOrSetRecord = <ObjectType extends Record<string, unknown>>(
  key: keyof ObjectType,
  defaultValue: NonNullable<ObjectType[keyof ObjectType]>,
  obj: ObjectType,
) => {
  const value = obj[key] ?? defaultValue;
  if (!obj[key]) {
    // eslint-disable-next-line no-param-reassign
    obj[key] = value;
  }
  return value;
};
